import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Card, Image, Tag, Skeleton } from 'antd';
import styled from 'styled-components';
//import DetailsField from 'pages/DetailsField';
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from '../../shared/utils';

const AntdCard = styled(Card)`
  width: 100%;
  margin-top: 28px;
  border: 0px;

  .ant-card-body {
    padding: 0px;
  }

  .Col-ImagField {
    display: flex;
    justify-content: center;
    img {
      border-radius: 10px;
      object-fit: cover;
      aspect-ratio: 4 / 3;
    }
    .ant-skeleton-element {
      width: 100%;
    }

    .ant-skeleton-image {
      width: auto;
    }
  }

  .Col-infoCard {
    line-height: initial;
    background: #ffff;
    padding-left: 20px;
    align-content: center;
    display: grid;
    p {
      font-family: 'Roboto', sans-serif;
      white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    }
  }


  .Title-field {
    font-weight: 500;
    font-size: 20px;
    color: #3742fa;
    margin-bottom: 0px;
  }

  .Title-sede {
    font-weight: 500;
    font-size: 20px;
    color: #1b1464;
    margin-bottom: 0px;
  }

  .Inf-direction {
    font-weight: 400;
    font-size: 16px;
    color: #616fa1;
    margin-bottom: 0px;
  }

  .Inf-description {
    font-weight: 400;
    font-size: 16px;
    color: #616fa1;
    margin-bottom: 0px;
    white-space: normal !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .Inf-distance, .Inf-field {
    font-weight: 500;
    font-size: 13px;
    color: #020609;
    margin-bottom: 0px;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 4px;
    column-gap: 8px;

    .ant-tag {
      margin-left: 0px !important;
      padding: 3px 12px !important;
    }
  }

  .Inf-distance {
    .ant-tag {
      font-weight: 400;
      font-size: 12px;
      color: #616fa1;
    }
  }

  .ant-tag {
    color: #020609;
    margin-left: 15px;
    padding: 5px 15px;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 12px;
    border-radius: 10px;
  }

  .Col-PriceRsvp {
    line-height: initial;
    text-align: right;
    p {
      font-family: 'Roboto', sans-serif;
    }
  }

  .text-price {
    font-weight: 400;
    font-size: 12px;
    color: #616fa1;
    margin-bottom: 0px;
  }

  .num-price {
    font-weight: 500;
    font-size: 26px;
    color: #616fa1;
    margin-bottom: 58px;
  }

  .ant-btn {
    width: 117px;
    background: #00e676;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #ffff;
    height: 44px;
    border: none;
    border-radius: 10px;
  }

  @media (max-width: 609px) {
    margin-top: 10px !important;
    border-radius: 10px;
    .ant-card-body {
      padding: 10px;
    }

     {
      .ant-image {
        height: 132px !important;
      }
      img {
        height: 100% !important;
      }
    }
    .Col-infoCard {
      display: inline-grid;
      align-content: center;
      padding-left: 10px;

      .Title-field {
        font-size: 14px;
      }
      .Title-sede {
        font-size: 14px;
      }
      .Inf-direction {
        font-size: 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .Inf-description {
        font-size: 12px;
        -webkit-line-clamp: 2;
      }
      .Inf-distance, .Inf-field {
        font-size: 12px;
        white-space: normal;
        overflow: visible;
        text-overflow: clip;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 2px;
        column-gap: 6px;
        margin-bottom: 0px;

        .ant-tag {
          font-size: 11px;
          margin-left: 0px !important;
          padding: 2px 8px !important;
          line-height: 1.5;
        }
      }

      .text-price {
        color: #1b1464 !important;
      }
      .num-price {
        margin-bottom: 0px;
      }
    }
  }
`;

const CardField = ({ fieldData, loading, timeValues, showDistance = true }) => {
  const isDesktop = useMediaQuery('(min-width: 609px)');
  const [dateTime, setDateTime] = useState(null);
  const location = useLocation();
  const isForSportCenter = !!process.env.REACT_APP_CENTER_KEY;
  const isClassesCard = location.pathname === '/searcher/classes' || fieldData?.activityType === 'clases';
  const fieldId = isClassesCard
    ? fieldData?.idclase || fieldData?.idcancha
    : fieldData?.idcancha;
  const detailsPath = isClassesCard
    ? (isForSportCenter ? `/classes/${fieldId}` : `/searcher/classes/${fieldId}`)
    : (isForSportCenter ? `/venue/${fieldData?.idsede}/field/${fieldId}` : `/searcher/fields/${fieldId}`);
  const title = isClassesCard
    ? fieldData?.nombre || fieldData?.nombrecancha
    : fieldData?.nombrecancha || fieldData?.nombre;
  const displayedSede = isClassesCard && fieldData?.nombrecancha && fieldData.nombrecancha !== fieldData.nombre && fieldData.nombrecancha !== 'Clase'
    ? `${fieldData.nombresede} - ${fieldData.nombrecancha}`
    : fieldData?.nombresede;
  const amount = fieldData?.monto ?? fieldData?.precio;
  const formattedAmount = amount !== undefined && amount !== null
    ? `$ ${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
    : '';
  const distance = Number(fieldData?.distance);
  const formattedDistance = Number.isFinite(distance) ? `${distance.toFixed(2)} km` : '';
  const availableSlots = fieldData?.sesiones;

  const parsedAvailableSlots = typeof availableSlots === 'boolean'
    ? NaN
    : Number(availableSlots);
  const displayedSlots = Number.isFinite(parsedAvailableSlots)
    ? parsedAvailableSlots
    : 1;
  const formattedAvailableSlots = Number.isFinite(displayedSlots)
    ? `${displayedSlots} ${displayedSlots === 1 ? 'sesión' : 'sesiones'}`
    : availableSlots;
  const shouldShowAvailableSlots =
    formattedAvailableSlots && typeof formattedAvailableSlots !== 'boolean';
  const selectedDateTime = dateTime || (timeValues ? timeValues() : null);

  const detailsState = {
    ...(location.state || {}),
    fieldData,
    dateTime: selectedDateTime,
    fromPath: location.pathname,
  };
  
  useEffect(() => {
    if (timeValues) {
      const getTimeValues = timeValues();
      setDateTime({
        date: getTimeValues.date,
        time: getTimeValues.time,
      });
    }
  }, [timeValues]);

  return (
    <AntdCard>
      {isDesktop ? (
        <>
          <Row>
            <Col span={6} className='Col-ImagField'>
              {loading ? (
                <>
                  <Skeleton.Image style={{ height: '160px', marginBottom: '10px' }} />
                </>
              ) : (
                <>
                  {/*<div style={{ background: '#FFDF00', width: '70px', height: '39px', position: 'absolute', zIndex: '2', display: 'flex', justifyContent: 'center', borderRadius: '0px 10px' }}>
                     <p style={{ color: '#1B1464', fontFamily: '"Roboto",  sans-serif', fontSize: '14px', fontWeight: '700', display: 'grid', alignContent: 'center', margin: '0px' }}>20% DTO</p>
                   </div>*/}
                  <Image height={160} preview={false} src={fieldData.imagen} />
                </>
              )}
            </Col>
            <Col span={11} className='Col-infoCard'>
              {loading ? (
                <>
                  <Skeleton active='true' paragraph={{ rows: 3 }} />
                </>
              ) : (
                <>
                  <p className='Title-field'>{title}</p>
                  <p className='Title-sede'>{displayedSede}</p>
                  {isClassesCard ? (
                    <>
                      <p className='Inf-direction'>{fieldData.direccion}</p>
                      <p className='Inf-distance' style={{ visibility: showDistance ? 'visible' : 'hidden' }}>
                        Distancia <Tag color='transparent'>{formattedDistance}</Tag>
                      </p>
                      {shouldShowAvailableSlots && (
                        <p className='Inf-field'>
                          Disponibilidad <Tag color='#FBB800'>{formattedAvailableSlots}</Tag>
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      <p className='Inf-direction'>{fieldData.direccion}</p>
                      <p className='Inf-distance' style={{ visibility: showDistance ? 'visible' : 'hidden' }}>
                        Distancia <Tag color='transparent'>{formattedDistance}</Tag>
                      </p>
                      <p className='Inf-field'>
                        Tipo de Cancha <Tag color='#FBB800'>{fieldData.clasificacionsiglas}</Tag>
                      </p>
                    </>
                  )}
                </>
              )}
            </Col>
            <Col span={7} className='Col-PriceRsvp'>
              {loading ? (
                <>
                  <div style={{ padding: '10px' }}>
                    <Skeleton active='true' paragraph={{ rows: 1 }} style={{ textAlign: 'right' }} />
                    <Skeleton.Button active='true' style={{ height: '54px' }} />
                  </div>
                </>
              ) : (
                <>
                  <p className='text-price'>{isClassesCard ? 'Valor por persona' : 'Valor por Hora'}</p>
                  <p className='num-price'>{formattedAmount}</p>
                  <Button type='Primary'>
                    <Link to={{ pathname: detailsPath, state: detailsState }}>Ver Detalle</Link>
                  </Button>
                </>
              )}
            </Col>
          </Row>
        </>
      ) : (
        <>
          {loading ? (
            <>
              <Row>
                <Col span={9} className='Col-ImagField'>
                  <Skeleton.Image style={{ height: '160px', marginBottom: '10px' }} />
                </Col>
                <Col span={15} className='Col-infoCard'>
                  <Skeleton active='true' paragraph={{ rows: 3 }} />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Link to={{ pathname: detailsPath, state: detailsState }}>
                <Row>
                  {/*  <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
                <div
                  style={{
                    background: '#FFDF00',
                    width: '53px',
                    height: '29px',
                    position: 'absolute',
                    zIndex: '2',
                    display: 'flex',
                    justifyContent: 'center',
                    borderRadius: '0px 10px',
                    top: '-10px',
                    right: '-10px',
                  }}>
                   <p style={{ color: '#1B1464', fontFamily: '"Roboto",  sans-serif', fontSize: '10px', fontWeight: '700', display: 'grid', alignContent: 'center', margin: '0px' }}>20% DTO</p>
                </div>
              </Col>*/}
                  <Col span={9} className='Col-ImagField'>
                    <Image height={160} preview={false} src={fieldData.imagen} />
                    {!isClassesCard && (
                      <div
                        style={{
                          background: '#FBB800',
                          width: '60px',
                          height: '23px',
                          position: 'absolute',
                          zIndex: '2',
                          display: 'flex',
                          justifyContent: 'center',
                          borderRadius: '6px',
                          top: '103px',
                          right: '10px',
                        }}>
                        <p style={{ color: '#1B1464', fontFamily: '"Roboto",  sans-serif', fontSize: '10px', fontWeight: '700', display: 'grid', alignContent: 'center', margin: '0px' }}>
                          {fieldData.clasificacionsiglas}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col span={15} className='Col-infoCard'>
                    <p className='Title-field'>{title}</p>
                    <p className='Title-sede'>{displayedSede}</p>
                    {isClassesCard ? (
                      <>
                        <p className='Inf-direction'>{fieldData.direccion}</p>
                        <p className='Inf-distance' style={{ visibility: showDistance ? 'visible' : 'hidden' }}>
                          Distancia <Tag color='transparent'>{formattedDistance}</Tag>
                        </p>
                        {shouldShowAvailableSlots && (
                          <p className='Inf-field'>
                            Disponibilidad <Tag color='#FBB800'>{formattedAvailableSlots}</Tag>
                          </p>
                        )}
                      </>
                    ) : (
                      <>
                        <p className='Inf-direction'>{fieldData.direccion}</p>
                        <p className='Inf-distance' style={{ visibility: showDistance ? 'visible' : 'hidden' }}>
                          Distancia <Tag color='transparent'>{formattedDistance}</Tag>
                        </p>
                      </>
                    )}
                    <p className='text-price'>{isClassesCard ? 'Valor por persona' : 'Valor por hora'}</p>
                    <p className='num-price'>{formattedAmount}</p>
                  </Col>
                </Row>
              </Link>
            </>
          )}
        </>
      )}
    </AntdCard>
  );
};

export default CardField;
